import moment from "moment";
import {
  SubscriptionPaymentMethodType,
  LanguageNameSpaces,
  SubscriptionDuration,
} from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

export const PRIMARY_API_HELPER_ARTICLE_ID = "5814837";
export const SECURE_CLIENT_INVITE_HELPER_ARTICLE_ID = "11098824";
export const INVOICING_HELPER_ARTICLE_ID = "13737605";

export const SUBSCRIPTION_QUERY_PARAMS = {
  DURATION: "duration",
  PLAN: "plan",
  PAYMENT_METHOD: "payment-method",
  STEP: "step",
  IS_ALL_PLANS: "all-plans",
  IS_UPGRADE: "is-upgrade",
} as const;

export const DURATION_TO_SECONDARY_DISPLAY: Record<
  SubscriptionDuration,
  TranslationKeys<LanguageNameSpaces.BILLING>
> = {
  [30]: "duration.monthly",
  [90]: "duration.quarterly",
  [180]: "duration.half_yearly",
  [360]: "duration.annually",
};

export const DURATION_TO_PRIMARY_DISPLAY: Record<
  SubscriptionDuration,
  TranslationKeys<LanguageNameSpaces.BILLING>
> = {
  [30]: "duration.month",
  [360]: "duration.year",
};

export const DURATION_TO_TIME_UNIT: Record<
  SubscriptionDuration,
  moment.unitOfTime.DurationConstructor
> = {
  [30]: "month",
  [360]: "year",
};

export const WEB_APPLE_PAY_SUBSCRIPTION_WARNING =
  "Your subscription was purchased through Apple Pay and can only be managed through our mobile app. Please use the app to make changes to your subscription.";

export const PAYMENT_OPTION_TO_DISPLAY_NAME = {
  [SubscriptionPaymentMethodType.PAYPAL]: "PayPal",
  [SubscriptionPaymentMethodType.APPLEPAY]: "ApplePay",
  [SubscriptionPaymentMethodType.APPLEPAY_SUBSCRIPTION]:
    "ApplePay Subscription",
  [SubscriptionPaymentMethodType.GOOGLEPAY_SUBSCRIPTION]:
    "GooglePay Subscription",
  [SubscriptionPaymentMethodType.USDT_TRC20]: "USDT (TRC20)",
  [SubscriptionPaymentMethodType.USDT_ERC20]: "USDT (ERC20)",
  [SubscriptionPaymentMethodType.USDC_ERC20]: "USDC (ERC20)",
  [SubscriptionPaymentMethodType.USDC_TRC20]: "USDC (TRC20)",
};
